var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-12" }, [
    _c(
      "div",
      { staticClass: "filter_el best__item" },
      [
        !_vm.itemData.localItem
          ? _c("div", { staticClass: "item_count" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.itemData.numbers) + "\n        "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "main__blck" }, [
          _c("div", { staticClass: "logo__blck" }, [
            _vm._m(1),
            _vm._v(" "),
            _vm.itemData.localItem
              ? _c("div", { staticClass: "local__blck" }, [_vm._m(2)])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "spec_items" }, [
              _c("div", { staticClass: "spec_item" }, [
                _c(
                  "div",
                  { staticClass: "icon", class: { active: _vm.active3 } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../img/icon/weather/sun.svg"),
                        alt: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.active3 = !_vm.active3
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.active3
                  ? _c(
                      "div",
                      {
                        staticClass: "mini-popup",
                        class: { active: _vm.active3 }
                      },
                      [_vm._m(4)]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "spec_item" }, [
                _c(
                  "div",
                  { staticClass: "icon", class: { active: _vm.active8 } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../img/icon/weather/bio.svg"),
                        alt: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.active8 = !_vm.active8
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.active8
                  ? _c(
                      "div",
                      {
                        staticClass: "mini-popup",
                        class: { active: _vm.active8 }
                      },
                      [_vm._m(5)]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "spec_item" }, [
                _c(
                  "div",
                  { staticClass: "icon", class: { active: _vm.active4 } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../img/icon/weather/environment.svg"),
                        alt: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.active4 = !_vm.active4
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.active4
                  ? _c(
                      "div",
                      {
                        staticClass: "mini-popup",
                        class: { active: _vm.active4 }
                      },
                      [_vm._m(6)]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "spec_item" }, [
                _c(
                  "div",
                  { staticClass: "icon", class: { active: _vm.active5 } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../img/icon/weather/water.svg"),
                        alt: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.active5 = !_vm.active5
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.active5
                  ? _c(
                      "div",
                      {
                        staticClass: "mini-popup",
                        class: { active: _vm.active5 }
                      },
                      [_vm._m(7)]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "spec_item" }, [
                _c(
                  "div",
                  { staticClass: "icon", class: { active: _vm.active6 } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../img/icon/weather/wind.svg"),
                        alt: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.active6 = !_vm.active6
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.active6
                  ? _c(
                      "div",
                      {
                        staticClass: "mini-popup",
                        class: { active: _vm.active6 }
                      },
                      [_vm._m(8)]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "spec_item" }, [
                _c(
                  "div",
                  { staticClass: "icon", class: { active: _vm.active7 } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../img/icon/weather/XLarge.png"),
                        alt: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.active7 = !_vm.active7
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.active7
                  ? _c(
                      "div",
                      {
                        staticClass: "mini-popup",
                        class: { active: _vm.active7 }
                      },
                      [_vm._m(9)]
                    )
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "price__blck" },
            [
              _c("div", { staticClass: "price_list" }, [
                _c("div", { staticClass: "price_item quest__in_parent" }, [
                  _c("p", { staticClass: "p-light-green med" }, [
                    _vm._v("Variable price")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "quest__in_icon",
                      class: { active: _vm.active1 },
                      on: {
                        click: function($event) {
                          _vm.active1 = !_vm.active1
                        }
                      }
                    },
                    [
                      _vm.active1
                        ? _c(
                            "div",
                            {
                              staticClass: "mini-popup",
                              class: { active: _vm.active1 },
                              on: {
                                click: function($event) {
                                  _vm.active1 = !_vm.active1
                                }
                              }
                            },
                            [_vm._m(10)]
                          )
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(11),
                _vm._v(" "),
                _vm._m(12),
                _vm._v(" "),
                _vm._m(13)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "more" }, [
                _c(
                  "button",
                  {
                    staticClass: "p-bold p-black",
                    class: { infOpen: _vm.infOpen },
                    on: {
                      click: function($event) {
                        _vm.infOpen = !_vm.infOpen
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../img/icon/more-plus.svg"),
                        alt: ""
                      }
                    }),
                    _vm._v("  More information / calculation")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.infOpen
                  ? _c("div", { staticClass: "info__blck" }, [
                      _c("div", { staticClass: "logo__blck" }, [
                        _c("p", { staticClass: "p-bold title-p" }, [
                          _vm._v("More about Fortum")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "min-min" }, [
                          _vm._v(
                            "Cheap, cheap and cheap. Then you can summarize Telinet Energi with three words. For us, the price is everything. At the same time, we never compromise on the environment: all our electricity is green and comes from renewable sources."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "price__blck" }, [
                        _c("div", { staticClass: "price_info_item" }, [
                          _c("p", { staticClass: "p-bold title-p" }, [
                            _vm._v("Fixed charge")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "min-min" }, [
                            _vm._v(
                              "The regular fixed annual fee is SEK 420 incl. VAT "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "price_info_item" }, [
                          _c("p", { staticClass: "p-bold title-p" }, [
                            _vm._v("Discount fixed fee")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "min-min" }, [
                            _vm._v(
                              "The anual fee is discounted SEK 420 / year incl. VAT for one year"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "price_info_item" }, [
                          _c("p", { staticClass: "p-bold title-p" }, [
                            _vm._v("Discount penny / kWh")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "min-min" }, [
                            _vm._v("SEK 8.00 / kWh excluding VAT")
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "action__blck" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-9" }, [
                            _c("div", { staticClass: "title" }, [
                              _c(
                                "p",
                                { staticClass: "relawaySM min p-dgrey" },
                                [_vm._v("Electricity price")]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "p-gray2 minimum" }, [
                                _vm._v(
                                  "(incl. electricity certificate, excl. VAT)"
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-3 d-flex align-items-center justify-content-end"
                            },
                            [
                              _c("div", { staticClass: "cost" }, [
                                _c(
                                  "p",
                                  { staticClass: "p-dgrey med-max p-bold" },
                                  [_vm._v("45.90")]
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-9" }, [
                            _c("div", { staticClass: "title" }, [
                              _c(
                                "p",
                                { staticClass: "relawaySM min p-dgrey" },
                                [_vm._v(" Fixed feese")]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "p-gray2 minimum" }, [
                                _vm._v("Monthly fee 36 SEK / month (excl. VAT)")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-3 d-flex align-items-center justify-content-end"
                            },
                            [
                              _c("div", { staticClass: "cost" }, [
                                _c(
                                  "p",
                                  { staticClass: "p-dgrey med-max p-bold" },
                                  [_vm._v("3.51")]
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-9" }, [
                            _c("div", { staticClass: "title" }, [
                              _c(
                                "p",
                                { staticClass: "relawaySM min p-dgrey" },
                                [_vm._v("Environmental Power on")]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "p-gray2 minimum" }, [
                                _vm._v(
                                  "No premium for environmental agreements"
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-3 d-flex align-items-center justify-content-end"
                            },
                            [
                              _c("div", { staticClass: "cost" }, [
                                _c(
                                  "p",
                                  { staticClass: "p-dgrey med-max p-bold" },
                                  [_vm._v("0.00")]
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-9" }, [
                            _c("div", { staticClass: "title" }, [
                              _c(
                                "p",
                                { staticClass: "relawaySM min p-dgrey" },
                                [_vm._v("Moms")]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "p-gray2 minimum" }, [
                                _vm._v("VAT, 25% ")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-3 d-flex align-items-center justify-content-end"
                            },
                            [
                              _c("div", { staticClass: "cost" }, [
                                _c(
                                  "p",
                                  { staticClass: "p-dgrey med-max p-bold" },
                                  [_vm._v("+ 12.35")]
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "action__blck" }, [
            _c("div", { staticClass: "two__blcks" }, [
              _c("div", { staticClass: "res_elec" }, [
                _c("p", { staticClass: "p-black" }, [
                  _c("span", { staticClass: "number" }, [_vm._v("36,32 ")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", [_vm._v("öre/kWh inkl")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "p-blue",
                      class: { active: _vm.active2 },
                      on: {
                        click: function($event) {
                          _vm.active2 = !_vm.active2
                        }
                      }
                    },
                    [_vm._v("inkl")]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(14),
              _vm._v(" "),
              _vm.active2
                ? _c(
                    "div",
                    {
                      staticClass: "mini-popup",
                      class: { active: _vm.active2 },
                      on: {
                        click: function($event) {
                          _vm.active2 = !_vm.active2
                        }
                      }
                    },
                    [_vm._m(15)]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "buttons" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-green btn-full",
                  on: {
                    click: function($event) {
                      return _vm.$emit("modalActive")
                    }
                  }
                },
                [_vm._v("Further")]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.infOpen
            ? _c("div", { staticClass: "info__blck desktop__blck" }, [
                _c("div", { staticClass: "logo__blck" }, [
                  _c("p", { staticClass: "p-bold title-p" }, [
                    _vm._v("More about Fortum")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "min-min" }, [
                    _vm._v(
                      "Cheap, cheap and cheap. Then you can summarize Telinet Energi with three words. For us, the price is everything. At the same time, we never compromise on the environment: all our electricity is green and comes from renewable sources."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "price__blck" }, [
                  _c("div", { staticClass: "price_info_item" }, [
                    _c("p", { staticClass: "p-bold title-p" }, [
                      _vm._v("Fixed charge")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "min-min" }, [
                      _vm._v(
                        "The regular fixed annual fee is SEK 420 incl. VAT "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "price_info_item" }, [
                    _c("p", { staticClass: "p-bold title-p" }, [
                      _vm._v("Discount fixed fee")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "min-min" }, [
                      _vm._v(
                        "The anual fee is discounted SEK 420 / year incl. VAT for one year"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "price_info_item" }, [
                    _c("p", { staticClass: "p-bold title-p" }, [
                      _vm._v("Discount penny / kWh")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "min-min" }, [
                      _vm._v("SEK 8.00 / kWh excluding VAT")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "action__blck" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-9" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("p", { staticClass: "relawaySM min p-dgrey" }, [
                          _vm._v("Electricity price")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "p-gray2 minimum" }, [
                          _vm._v("(incl. electricity certificate, excl. VAT)")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-3 d-flex align-items-center justify-content-end"
                      },
                      [
                        _c("div", { staticClass: "cost" }, [
                          _c("p", { staticClass: "p-dgrey med-max p-bold" }, [
                            _vm._v("45.90")
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-9" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("p", { staticClass: "relawaySM min p-dgrey" }, [
                          _vm._v(" Fixed feese")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "p-gray2 minimum" }, [
                          _vm._v("Monthly fee 36 SEK / month (excl. VAT)")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-3 d-flex align-items-center justify-content-end"
                      },
                      [
                        _c("div", { staticClass: "cost" }, [
                          _c("p", { staticClass: "p-dgrey med-max p-bold" }, [
                            _vm._v("3.51")
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-9" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("p", { staticClass: "relawaySM min p-dgrey" }, [
                          _vm._v("Environmental Power on")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "p-gray2 minimum" }, [
                          _vm._v("No premium for environmental agreements")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-3 d-flex align-items-center justify-content-end"
                      },
                      [
                        _c("div", { staticClass: "cost" }, [
                          _c("p", { staticClass: "p-dgrey med-max p-bold" }, [
                            _vm._v("0.00")
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-9" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("p", { staticClass: "relawaySM min p-dgrey" }, [
                          _vm._v("Moms")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "p-gray2 minimum" }, [
                          _vm._v("VAT, 25% ")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-3 d-flex align-items-center justify-content-end"
                      },
                      [
                        _c("div", { staticClass: "cost" }, [
                          _c("p", { staticClass: "p-dgrey med-max p-bold" }, [
                            _vm._v("+ 12.35")
                          ])
                        ])
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "best_partner" }, [
      _c("img", { attrs: { src: require("../../../img/Badge.svg"), alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stiker__blck" }, [
      _c("img", {
        attrs: { src: require("../../../img/clients/Kampanj_icn.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "marker" }, [
      _c("img", { attrs: { src: "/img/marker.svg", alt: "" } }),
      _vm._v("Stockholm")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", { attrs: { src: require("../../../img/fortum.svg"), alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Fast price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable ous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Fast price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable ous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Fast price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable ous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Fast price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable ous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Fast price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable ous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Fast price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable ous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Variable price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "price_item" }, [
      _c("p", { staticClass: "p-bold" }, [_vm._v("The terms apply")]),
      _vm._v(" "),
      _c("p", { staticClass: "bg-p" }, [_vm._v("24 month")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "price_item" }, [
      _c("p", { staticClass: "p-bold" }, [_vm._v("Notice period")]),
      _vm._v(" "),
      _c("p", { staticClass: "bg-p" }, [_vm._v("30 days")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "price_item" }, [
      _c("p", { staticClass: "p-bold" }, [_vm._v("Annual cost")]),
      _vm._v(" "),
      _c("p", { staticClass: "bg-p" }, [_vm._v("5461 kr")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "res_price" }, [
      _c("p", { staticClass: "p-black" }, [
        _c("span", { staticClass: "number" }, [_vm._v("1250")]),
        _vm._v(" "),
        _c("span", [_vm._v("kr")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("span", [_vm._v("month SEK")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "relawaySM min p-dgrey" }, [
              _vm._v("Electricity price")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [
              _vm._v("(incl. electricity certificate, excl. VAT)")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max p-bold" }, [
                _vm._v("45.90")
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "relawaySM min p-dgrey" }, [
              _vm._v(" Fixed feese")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [
              _vm._v("Monthly fee 36 SEK / month (excl. VAT)")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max p-bold" }, [
                _vm._v("3.51")
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "relawaySM min p-dgrey" }, [
              _vm._v("Environmental Power on")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [
              _vm._v("No premium for environmental agreements")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max p-bold" }, [
                _vm._v("0.00")
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "relawaySM min p-dgrey" }, [_vm._v("Moms")]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [_vm._v("VAT, 25% ")])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max p-bold" }, [
                _vm._v("+ 12.35")
              ])
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }